import { AdminConfiguration } from '@centecomm/admin-config-service';
import { TenantSettings, UserPermissions } from '@centecomm/portal-service';
import { NounIconChat, NounIconInvoice, NounIconLease, NounNewRequest, NounQuestionMark } from '../../../Icons';
import { DashboardLink } from '../Types/DashboardLink';

const getTenantLinks = (
    hasPermission: (permission: UserPermissions) => boolean,
    settings: AdminConfiguration | undefined,
    complianceHubEnabled: boolean = false,
): DashboardLink[] => {
    const linksForUser: DashboardLink[] = [];

    const invoiceEnabled =
        (settings as AdminConfiguration)?.invoice?.enabled || (settings as TenantSettings)?.invoice?.visible;

    if (
        hasPermission(UserPermissions.CreateRequest) &&
        settings?.request?.visible &&
        (settings?.landingPage?.createRequestTenant ?? true)
    ) {
        linksForUser.push({
            text: 'Create a Request',
            url: '/requests/create',
            Icon: NounIconChat,
        });
    }

    if (
        hasPermission(UserPermissions.ViewRequests) &&
        settings?.request?.visible &&
        (settings?.landingPage?.viewRequestTenant ?? true)
    ) {
        linksForUser.push({
            text: 'View New Requests',
            url: '/requests/new',
            Icon: NounNewRequest,
        });
    }

    if (
        hasPermission(UserPermissions.ViewInvoices) &&
        invoiceEnabled &&
        hasPermission(UserPermissions.CreateRequest) &&
        settings?.request?.visible &&
        (settings?.landingPage?.viewInvoiceQuestionTenant ?? true)
    ) {
        linksForUser.push({
            text: 'Submit Invoice Question',
            url: '/requests/create?category=billing',
            Icon: NounQuestionMark,
        });
    }

    if (
        hasPermission(UserPermissions.ViewInvoices) &&
        invoiceEnabled &&
        (settings?.landingPage?.payMyInvoiceTenant ?? true)
    ) {
        linksForUser.push({
            text: 'Pay My Invoice',
            url: '/invoices',
            Icon: NounIconInvoice,
        });
    }

    if (
        hasPermission(UserPermissions.ViewDocuments) &&
        settings?.documentManagement?.visible &&
        (settings?.landingPage?.viewLeaseTenant ?? true)
    ) {
        linksForUser.push({
            text: 'View Lease',
            url: '/documents',
            Icon: NounIconLease,
        });
    }

    if (
        hasPermission(UserPermissions.ViewInvoices) &&
        invoiceEnabled &&
        hasPermission(UserPermissions.CreateRequest) &&
        settings?.request?.visible &&
        (settings?.landingPage?.submitFinancialStatementTenant ?? true)
    ) {
        linksForUser.push({
            text: 'Submit Financial Statement',
            url: '/requests/create?category=billing',
            Icon: NounIconInvoice,
        });
    }
    return linksForUser;
};

export default getTenantLinks;
